<div class="container">
  <div
    [class.expanded]="expanded"
    [class.up]="up"
    class="chips"
    *ngIf="expanded"
  >
    <chip-input
      [chips]="chips"
      [placeholder]="placeholder"
      [search]="search"
      [up]="up"
      [autocompletePreferredPosition]="
        up ? AnchoredPosition.TOP_RIGHT : AnchoredPosition.BOTTOM_RIGHT
      "
      [isValid]="isValid"
      (rvChange)="rvChange.next($event)"
    ></chip-input>
  </div>
  <button class="rv-flex" (click)="expanded = !expanded">
    {{ text }}
    <riv-icon [name]="up !== expanded ? 'ChevronUp' : 'ChevronDown'"></riv-icon>
  </button>
</div>
